export interface PendingHttpRequest {
    start: () => void;
}

export class HttpConcurrencyQueueFullError extends Error {
    constructor() {
        super("The HTTP request queue is full. Try again after the current requests finish.");
        this.name = "HttpConcurrencyQueueFullError";
    }
}
